import React from 'react'
import './Footer.css'
import TopLogo from '../../components/TopLogo'

function Footer() {
    let mobile = window.innerWidth < 600
    return (
        <div className='footer'>
            <div id='carrer' style={{ backgroundColor: 'rgba(255, 255, 255, 0.446)' }}>
                <div className="footer-content">
                    <div className="footer-link">
                        <h4>FLYXAVI LIAISONSHIP</h4>
                        <ul>
                            <li><i className="far fa-hand-point-right" />AIRCRAFT SALE/RESALE</li>
                            <li><i className="far fa-hand-point-right" />ENGINE SALE/RESALE</li>
                            <li><i className="far fa-hand-point-right" />AIRCRAFT &#38; ENGINE {mobile ? <></> : <br />}
                                COMPONENTS / SPARE SALES</li>
                            <li><i className="far fa-hand-point-right" />AIRCRAFT &#38; ENGINE {mobile ? <></> :<br />}
                                LEASE/ACMI</li>
                        </ul>
                    </div>
                    <div className="footer-link">
                        <h4>PROJECT CAPABILITY</h4>
                        <ul>
                            <li><i className="far fa-hand-point-right" />PRE-PURCHASE</li>
                            <li><i className="far fa-hand-point-right" />NEW AIRCRAFT DELIVERY</li>
                            <li><i className="far fa-hand-point-right" />MID-TERM{mobile ? <></> :<br />}
                                /INTERMIDIATEAUDIT</li>
                            <li><i className="far fa-hand-point-right" />ANNUAL AUDIT</li>
                            <li><i className="far fa-hand-point-right" />RE-DELIVERY</li>
                        </ul>
                    </div>
                    <div className="footer-link">
                        <h4>TRANSITION SUPPORT<br />CAPACITY</h4>
                        <ul>
                            <li><i className="far fa-hand-point-right" />PHYSICAL INSPECTION</li>
                            <li><i className="far fa-hand-point-right" />BORESCOPE INSPECTION</li>
                            <li><i className="far fa-hand-point-right" />ENGINE/NACELLE {mobile ? <></> :<br />}INSPECTION</li>
                            <li><i className="far fa-hand-point-right" />STRUCTURE INSPECTION</li>
                            <li><i className="far fa-hand-point-right" />WORKSCOPE REVIEW</li>
                            <li><i className="far fa-hand-point-right" />RECORD REVIEW</li>
                            <li><i className="far fa-hand-point-right" />BACK TO BIRTH{mobile ? <></> :<br />}TRACEABILITY</li>
                            <li><i className="far fa-hand-point-right" />DESKTOP ASSESSMENT</li>
                        </ul>
                    </div>
                    <div className="footer-link">
                        <h4>BORESCOPE/THRUST<br />REVERSER SUPPORT</h4>
                        <ul>
                            <li><i className="far fa-hand-point-right" />CFM56 (ALL SERIES)</li>
                            <li><i className="far fa-hand-point-right" />CFM LEAP (ALL SERIES)</li>
                            <li><i className="far fa-hand-point-right" />GE CF6 (ALL SERIES)</li>
                            <li><i className="far fa-hand-point-right" />GR90 (ALL SERIES)</li>
                            <li><i className="far fa-hand-point-right" />GENX (ALL SERIES)</li>
                            <li><i className="far fa-hand-point-right" />GP7200 (ALL SERIES)</li>
                            <li><i className="far fa-hand-point-right" />ROLLS ROYCE RB211 TRENT {mobile ? <></> :<br />}(500-900 SERIES)</li>
                            <li><i className="far fa-hand-point-right" />PRATT &#38; WHITNEY PW4000{mobile ? <></> : <br /> }(ALL SERIES)</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div id='footer' style={{ backgroundColor: 'rgba(255, 255, 255, 0.446)' }}>
                <div className="footer-component">
                    <div className="company">
                        <div><img alt='' src='../../IMAGES/logo1.png' /></div>
                        <div className='row company-name'>
                            <img src={require('../../IMAGES/logo1.png')}></img>
                            <div style={{ paddingLeft: '5px' }}>
                                <h3 style={{ fontSize: '30px', letterSpacing: '1px' }}>FLYXAVI</h3>
                                <h5>AVIATION SERVICES</h5>
                            </div>
                        </div>
                    </div>
                    <div className="footer-contacts">
                        <div>
                            <h3>General</h3>
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li><a href="/">About</a></li>
                                <li><a href="/">Services</a></li>
                            </ul>
                        </div>
                        <div>
                            <h3>Email Contact</h3>
                            <ul>
                                <li><i className="far fa-envelope" /><a href="mailto:connect@flyxavi.com">connect@flyxavi.com</a></li>
                                <li><i className="far fa-envelope" /><a href="mailto:life@flyxavi.com">life@flyxavi.com</a></li>
                                <li><i className="far fa-envelope" /><a href="mailto:flysales@flyxavi.com">flysales@flyxavi.com</a></li>
                                <li><i className="far fa-envelope" /><a href="mailto:projects@flyxavi.com">projects@flyxavi.com</a></li>
                            </ul>
                        </div>
                        <div>
                            <h3>Contact Address</h3>
                            <ul>
                                <li>FLYXAVI SOLUTIONS LLP.</li>
                                <li>BANGOLORE, INDIA. 562107</li>
                                <li><i className="fab fa-whatsapp" /> +91-91732-91723</li>
                                <li><i className="fab fa-whatsapp" /> +91-91732-91723</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="follow">
                    <span>Follow us</span> <i className="fab fa-facebook" /> <i className="fab fa-linkedin" /> <i className="fab fa-instagram" />
                </div>
            </div>
        </div>
    )
}
export default Footer
